import {
  Theme,
  useTranslation,
  Modal,
  Button,
  ButtonAlignment,
  ButtonStyles,
  ButtonSize,
  useSession,
} from '@nextgen-web-framework/all';
import {
  Cart,
  CartConstantsEnum,
  SubCartDetail,
  cartApi,
  updateCart,
  type CartEntryDetails,
} from '@commerce-cart-webcomponents/sdk';
import { CheckoutCard } from '@commerce-product-webcomponents/ui';
import { useDispatch } from 'react-redux';
import { StorageService } from '@nextgen-web-framework/core';
import { useFeatureFlag } from '../../common';
import styles from './ItemsRemovedModal.module.scss';

export type ItemsRemovedModalProps = {
  removedEntries: Array<CartEntryDetails>;
  currentActiveCart?: SubCartDetail;
  orderType?: string;
};
const ItemsRemovedModal = ({ removedEntries, currentActiveCart }: ItemsRemovedModalProps) => {
  const { hideBVFlag } = useFeatureFlag();
  const t = useTranslation();
  const { isABO } = useSession();
  const doneButton = t('cart.ItemsRemovedModal.done');
  const dispatch = useDispatch();
  const removedEntriesPayload = removedEntries?.map(({ entryId, product, partnerPromotionId }) => ({
    entryId,
    product: {
      id: product.id,
    },
    partnerPromotionId,
    quantity: 0,
  }));

  const onDoneClickHandler = () => {
    cartApi
      .updateCartEntries({
        cartId: StorageService.getLocalStorage().retrieve(CartConstantsEnum.CartId),
        subCartId: currentActiveCart?.subCartId,
        payload: {
          subCarts: [
            {
              subCartId: currentActiveCart?.subCartId,
              entries: removedEntriesPayload,
            },
          ],
          version: +StorageService.getLocalStorage().retrieve(CartConstantsEnum.CartReqVersion),
        },
      })
      .then((res) => {
        dispatch(updateCart(res as Cart));
      });
  };

  return (
    <Modal
      buttonAlignment={ButtonAlignment.VERTICAL}
      primaryButtonLabel={''}
      headline={t('cart.ItemsRemovedModal.itemsRemoved')}
      closeIcon={false}
    >
      <>
        <div className={styles['itemsRemoved-modal-container']}>
          <div className={styles['itemsRemoved-modal-container-heading']}>
            {t('cart.ItemsRemovedModal.itemsRemovedHeading')}
          </div>
          {removedEntries?.map((entry: CartEntryDetails) => (
            <CheckoutCard
              key={entry.entryId}
              className={styles['checkout-card-component']}
              pointValue={isABO() ? String(entry.totalPrice?.amwayValue?.pointValue) : ''}
              businessVolume={isABO() && !hideBVFlag ? String(entry.totalPrice?.amwayValue?.businessVolume) : ''}
              productPrice={entry.totalPrice?.value}
              productSize=""
              productId={entry.product.id}
              productName={entry.product.name as string}
              productQuantity={entry.quantity}
              link={entry.product.cartIconPublicUrl as string}
              alt={entry.product.cartIconPublicUrl as string}
              brandName={entry.product.brand as string}
            />
          ))}
        </div>
        <div className={styles['done-button-container']}>
          <Button
            title={doneButton}
            buttonStyle={ButtonStyles.SOLID}
            theme={Theme.BLACK}
            size={ButtonSize.MEDIUM}
            role="button"
            onClick={onDoneClickHandler}
            aria-label={doneButton}
          />
        </div>
      </>
    </Modal>
  );
};

export { ItemsRemovedModal };
